import React from "react";
import styles from "./PackageCard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faCalendar,  faGauge,} from "@fortawesome/free-solid-svg-icons";
export default function PackageCard({ pkg }) {
  return (
    <div className={styles.card}>
      <div className={styles.imageWrapper}>
        <img
          src={pkg.image}
          alt={pkg.title}
          className={styles.image}
        />
        <span className={styles.badge}>{pkg.duration}</span>
      </div>

      <div className={styles.content}>
        <h3 className={styles.title}>{pkg.title}</h3>

        <div className={styles.meta}>
          <span><FontAwesomeIcon icon={faCalendar}/> {pkg.days}</span>
          <span><FontAwesomeIcon icon={faGauge}/> {pkg.difficulty}</span>
        </div>

        <div className={styles.footer}>
         <div> 
          <p className={styles.pricec}>Starting From</p>
          <p className={styles.price}>${pkg.price}</p></div>
          <Link to={pkg.link} className={styles.btn}>
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
}